<template>
  <GmapPolygon
    v-if="point.geofence.type === 'POLYGON'"
    :key="`geofence-polygon-${point.id}`"
    :paths="polygon"
    :options="{
      strokeColor: '#033380',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#4c8df5',
      fillOpacity: 0.35,
      clickable: false,
    }"
  />

  <GmapCircle
    v-else-if="point.geofence.type === 'CIRCLE'"
    :key="`geofence-circle-${point.id}`"
    :visible="true"
    :center="{
      lat: point.lat,
      lng: point.lng,
    }"
    :radius="point.geofence.radius || 100"
    :options="{
      strokeColor: '#033380',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#4c8df5',
      fillOpacity: 0.35,
      clickable: false,
    }"
  />
</template>

<script>
export default {
  props: {
    point: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    polygon() {
      if (!this.point?.geofence || this.point.geofence.type !== 'POLYGON') {
        return null
      }

      return this.point.geofence.polygon.map(item => {
        return {
          lat: item.latitude,
          lng: item.longitude,
        }
      })
    },
  },
}
</script>
